var _SpriteSymbol = require("/runner/_work/CertifyApp/CertifyApp/node_modules/rspack-plugin-svg-sprite/dist/runtime/symbol");
var SpriteSymbol = _SpriteSymbol.default || _SpriteSymbol;
var symbol = new SpriteSymbol({"id":"home-black","viewBox":"0 0 24 24","content":"<symbol id=\"home-black\" viewBox=\"0 0 24 24\" fill=\"black\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z\"/></symbol>"});
symbol.url = "/Scripts/dist/sprite.svg#home-black";
export default symbol;
